
class CapViewStudentNotification {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_student_notification'
}

function create(config) {
  return new CapViewStudentNotification(config)
}

export default {
  key,
  create,
}
